import React from 'react';
import { useParams } from 'react-router-dom';
import FleetOverview from './FleetOverview';

export default function Tables() {
    const { type } = useParams();

    return <FleetOverview type={type} />;
}
